export const panelListItems = [
  {
    id: 'templates',
    name: 'Templates',
  },
  {
    id: 'elements',
    name: 'Elements',
  },
  {
    id: 'image',
    name: 'Images',
  },
  {
    id: 'uploads',
    name: 'Uploads',
  },
  {
    id: 'text',
    name: 'Text',
  },
  {
    id: 'illustrations',
    name: 'Illustrations',
  },
  // {
  //   id: 'background',
  //   name: 'Background',
  // },
  {
    id: 'pixabay',
    name: 'Pixabay',
  },
]

export enum PanelType {
  TEMPLATES = 'Templates',
  BACKGROUND = 'Background',
}
